import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row, Card, Form, Button, Image, Modal } from "react-bootstrap";
import { login } from "ServerAPI/serverAPI";
import { useCookies } from "react-cookie";
import { Formik } from "formik";
import WarningIcon from "@mui/icons-material/Warning";

// Import media files
import Logo from "assets/images/krtrimaiqlogo.png";
import signin from "assets/images/signin.svg";
import loginpage from "assets/images/loginpage.svg";
import { useMsal } from "@azure/msal-react";
import { useToast } from "context/toast-context/ToastProvider";

const SignIn = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [cookies, setCookies] = useCookies([
    "email",
    "roleId",
    "roleName",
    "name",
    "phoneNumber",
    "accessToken",
    "features",
  ]);
  const [modal, setModal] = useState(false);
  const { instance } = useMsal();
  const { showToast } = useToast();

  // const handleAzureLogin = () => {
  //     instance.loginPopup().then((response) => {
  //         console.log(response.account);
  //         handleLogin({ email: response?.account?.username });
  //         return instance.setActiveAccount(response.account);
  //     });
  // };

  const handleAzureLogin = async () => {
    try {
      const response = await instance.loginPopup();

      if (response?.account) {
        console.log("Login Successful:", response.account);

        // Handle login, e.g., update state or call API
        handleLogin({ email: response.account.username });

        // Set active account for future authentication requests
        instance.setActiveAccount(response.account);
      } else {
        console.error("No account found in response.");
      }
    } catch (error) {
      console.error("Azure SSO Login Failed:", error);
    }
  };
  useEffect(() => {
    handleAzureLogin();
  }, []);

  const handleLogin = async (values) => {
    console.log(values);

    setLoading(true);

    try {
      const payload = {
        loginType: "sso",
        email: values.email,
      };
      const response = await login(payload);
      const { data } = response;

      setCookies("email", data.email, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("roleId", data.role.roleId, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("roleName", data.role.roleName, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("name", data.name, { secure: true, sameSite: "strict" });
      setCookies("organizationId", data.organizationId, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("phoneNumber", data.phoneNumber, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("department", data.department, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("domain", data.domain, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("userId", data.userId, {
        secure: true,
        sameSite: "strict",
      });
      setCookies("features", JSON.stringify(data.features), {
        secure: true,
        sameSite: "strict",
      });

      setCookies("userManagement", data.userManagement, {
        secure: true,
        sameSite: "strict",
      });

      navigate("/dashboard/overview");
    } catch (error) {
      console.log("error_", error);

      if (error.response?.status === 401) {
        setModal(true);
      } else {
        showToast(error?.response?.data?.message, "error");
        // alert("An unexpected error occurred.");
      }
    } finally {
      setLoading(false); // Set loading to false after the response or error
    }
  };

  const overlayStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100vw",
    position: "fixed",
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1000,
  };

  return (
    <>
      {loading && (
        <div style={overlayStyle}>
          <Spinner />
        </div>
      )}
      <Fragment>
        <Row className="align-items-center justify-content-center ">
          {/* Second Column (Right-Aligned) */}
          <Col lg={12} md={12} className="py-8 mx-0 py-xl-0">
            <Card className="shadow-lg">
              <Card.Header
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: " #23479F",
                }}
              >
                Open the Login Pop up or refresh the page
              </Card.Header>
              <Card.Body className="p-4">
                {/* <div className="mb-4">
                                    <Image
                                        style={{ width: "50%" }}
                                        src={Logo}
                                        className="mb-4 signuplogo"
                                        alt=""
                                    />
                                    <h1 className="mb-1 fw-bold">Sign in</h1>
                                </div> */}
                <Formik
                  initialValues={{ email: "" }}
                  onSubmit={async (values) => {
                    handleLogin(values);
                  }}
                >
                  {({ handleSubmit, handleChange, values }) => (
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col lg={12} md={12} className="mb-3">
                          {/* <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Enter email address"
                            value={values.email}
                            onChange={handleChange}
                            required
                          /> */}
                        </Col>
                        {/* <Col
                                                    lg={12}
                                                    md={12}
                                                    className="mb-2"
                                                >
                                                    <Form.Label>
                                                        Password
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="password"
                                                        id="email"
                                                        name="email"
                                                        placeholder="Enter password"
                                                        // value={values.email}
                                                        // onChange={handleChange}
                                                        // required
                                                    />
                                                </Col> */}
                        {/* <Col
                                                    lg={12}
                                                    md={12}
                                                    className="mb-3"
                                                >
                                                    <h5 
                                                        style={{
                                                        color: " #23479F",
                                                        textDecoration: "underline",
                                                        cursor: "pointer"
                                                    }}>
                                                        Forgot Password ?
                                                    </h5>
                                                </Col> */}
                        <Col lg={12} md={12} className="mb-0 d-grid gap-2">
                          {/* <Button
                            variant="w-100"
                            type="submit"
                            style={{
                              background: " #23479F",
                              color: "#FFFFFF",
                            }}
                          >
                            Continue
                          </Button> */}

                          {/* <Button
                                                        variant="primary w-100"
                                                        onClick={() =>
                                                            handleAzureLogin()
                                                        }
                                                    >
                                                        Login with Azure
                                                    </Button> */}
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Modal
          show={modal}
          onHide={() => setModal(false)}
          centered
          className="w-[10vw]"
        >
          <Modal.Body
            style={{
              display: "flex",
              alignItems: "center",
              padding: "16px",
            }}
          >
            {/* <WarningIcon style={{ color: '#F59E0B', width: '24px', height: '24px',paddingTop:"0px" }} /> */}
            <h3>Unauthorized. Please check your credentials.</h3>
          </Modal.Body>

          <div className="d-flex justify-content-center mb-3">
            <Button variant="primary" onClick={() => setModal(false)}>
              OK
            </Button>
          </div>
        </Modal>
      </Fragment>
    </>
  );
};

const Spinner = () => {
  const overlayStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100vw",
    position: "fixed",
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1000,
  };

  return (
    <>
      <style>
        {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
      </style>
      <div style={overlayStyle}>
        <div
          style={{
            animation: "spin 1s linear infinite",
            borderRadius: "50%",
            height: "10rem",
            width: "10rem",
            borderTop: "2px solid #224b99",
            borderBottom: "2px solid #224b99",
          }}
        ></div>
      </div>
    </>
  );
};
export default SignIn;
